var modules_65386100 = {"text":"Service_module_text__c1b84a6b"};
import "../../../../assets/esm/components/SelectionCalculator/components/Service/Service~CM_QmHJm.css";

export { modules_65386100 as default };
//# sourceMappingURL=Service.module.scss.js.map
